import React, { useEffect, useState } from "react";
import styles from "./recent-shipments.module.css";
import { getShippedShipments } from "@/api/fulfillment";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { useUserContext } from "@/contexts/UserContext";
import ShipmentStatusBadge from "../ShipmentStatusBadge/ShipmentStatusBadge";

type RecentShipmentRecord = {
  id: number;
  shipmentId: string;
  name: string;
  status?: string;
  percentageReceived?: string;
  totalUnits: number;
  totalSkus: number;
  createdAt: Date;
  fromSync: boolean;
};

type RecentShipmentProps = {};

const RecentShipments = ({}: RecentShipmentProps) => {
  const { seller } = useUserContext();
  const [recentShipments, setRecentShipments] = useState<RecentShipmentRecord[]>([]);
  const [recentShipmentsLoading, setRecentShipmentsLoading] = useState<boolean>(false);

  const handleGetRecentShipments = async () => {
    return await getShippedShipments(0, 6)
      .then(res => {
        const newRecentShipments: RecentShipmentRecord[] = [];
        for (const shipment of res.shipments) {
          let totalUnits = 0;
          let totalUnitsReceived = 0;
          for (const item of shipment.items) {
            totalUnits += item.quantity;
            totalUnitsReceived += item.quantityReceived;
          }

          newRecentShipments.push({
            id: shipment.id,
            shipmentId: shipment.shipmentId,
            name: shipment.shipmentName,
            status: shipment.status,
            totalSkus: shipment.items.length,
            totalUnits,
            percentageReceived: String(Math.round((totalUnitsReceived / totalUnits) * 100) || 0),
            createdAt: shipment.createdAt,
            fromSync: shipment.fromSync,
          })
        }
        setRecentShipments([...newRecentShipments]);
        //setRecentShipmentsLoading(true);
      });
  };

  useEffect(() => {
    if (seller && !recentShipmentsLoading) {
      setRecentShipmentsLoading(true);
      handleGetRecentShipments().finally(() => { setRecentShipmentsLoading(false) });
    }
  }, [seller]);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className="strong">Recent Shipments</span>
        {/* <Select          
          defaultOption="Last updated"
          options={["Last updated","Past 24 hours","Past week","Past Month","Past 3 months"]}
        /> */}
      </div>
      {recentShipmentsLoading && (
        <div className={styles.loaderContainer}>
          <LoadingSpinner size="3rem" />
        </div>
      )}
      {!recentShipmentsLoading && (
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr className={styles.tr}>
              <th scope="col" className={styles.th}>
                <div className={`${styles.shipmentName} strong`}>Name</div>
              </th>
              <th scope="col" className={`${styles.th} strong`}>Status</th>
              <th scope="col" className={`${styles.th} strong`}>Units</th>
              <th scope="col" className={`${styles.th} strong`}>% of units received</th>
            </tr>
          </thead>
          <tbody>
            {recentShipments.map((shipment, i) => {
              const createdAt = new Date(shipment.createdAt).toLocaleString("default", { dateStyle: "medium" });
              let percentageReceived = parseInt(shipment.percentageReceived);
              if (percentageReceived > 100) percentageReceived = 100; //Ensure that the max is always 100%.
              
              return (
                <tr key={i} className={styles.tr}>
                  <td>
                    <div className={styles.shipmentNameContainer}>
                      <div className={styles.shipmentNameCell}>{shipment.name}</div>
                      <div className={styles.shipmentCreatedAt}>{createdAt}</div>
                    </div>
                  </td>
                  <td>
                    <ShipmentStatusBadge status={shipment.status} />
                  </td>
                  <td>{shipment.totalUnits}</td>
                  <td>
                    <div className={styles.percentageReceivedContainer}>
                      <div className={`${percentageReceived > 0 ? styles.percentageReceivedText : ""}`}>{shipment.percentageReceived}%</div>
                      {percentageReceived > 0 && (
                        <div
                          className={styles.percentageReceivedLoader}
                          style={{
                            width: `${percentageReceived}px`
                          }}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default RecentShipments;